import { FC, Fragment, ReactElement, useCallback, useState } from 'react';

import { Action } from '@hh.ru/magritte-ui-action';
import { EllipsisHorizontalOutlinedSize24 as Ellipsis } from '@hh.ru/magritte-ui-icon/icon';
import { NavigationBarItem } from '@hh.ru/magritte-ui-navigation-bar/NavigationBarItem';
import {
    MAX_ICONS,
    NavigationBarItemArrayProps,
    NavigationBarProps,
    NavigationBarSize,
} from '@hh.ru/magritte-ui-navigation-bar/types';

interface NavigationBarItemsProps {
    items?: NavigationBarItemArrayProps;
    size: NavigationBarSize;
    renderFunc?: NavigationBarProps['ellipsisRenderFunc'];
}

const defaultRenderFunc = () => null;

export const NavigationBarItems: FC<NavigationBarItemsProps> = ({ items, size, renderFunc = defaultRenderFunc }) => {
    const [ellipsis, setEllipsis] = useState(false);
    const toggleEllipsis = useCallback(() => setEllipsis(!ellipsis), [ellipsis, setEllipsis]);

    if (!items) {
        return null;
    }

    if (items && 'length' in items) {
        if (size === 'standard' && items.length > 2) {
            return (
                <Fragment>
                    {ellipsis && renderFunc(items.slice(-MAX_ICONS, -1))}
                    <NavigationBarItem
                        data-qa="navigation-bar-ellipsis"
                        item={<Action icon={Ellipsis} onClick={toggleEllipsis} />}
                        transitionWithOpacity
                    />
                    <NavigationBarItem role="menuitem" item={items[items.length - 1]} />
                </Fragment>
            );
        }

        return (
            <Fragment>
                {items.slice(-MAX_ICONS).map((item, index) => (
                    <NavigationBarItem
                        role="menuitem"
                        item={item}
                        key={item.key || index}
                        transitionWithOpacity={
                            index !== items.length - 1 && (index !== items.length - 2 || items.length !== 2)
                        }
                    />
                ))}
            </Fragment>
        );
    }

    return <NavigationBarItem role="menuitem" item={items as ReactElement} />;
};
